import { TextField, Box } from "@mui/material";
import React, { useRef, useState, useEffect } from "react";

import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

export function CurrencyAnswer({ name, label, value = "", onChange, ...rest }) {
  const [isFocused, setIsFocused] = React.useState(false);
  const inputRef = useRef(null);

  const [digits, setDigits] = useState(digitsOnly(value));

  useEffect(() => setDigits(digitsOnly(value)), [value]);

  const display = formatCurr(digits);

  const handle = (e) => {
    const rawInput = e.target.value;
    const caretPos = e.target.selectionStart ?? 0;

    const nextDigits = digitsOnly(rawInput);
    setDigits(nextDigits);
    onChange(name, nextDigits === "" ? "" : digitsToNum(nextDigits).toFixed(2));

    const newDisplay = formatCurr(nextDigits);
    const diff = newDisplay.length - rawInput.length;
    requestAnimationFrame(() => {
      inputRef.current?.setSelectionRange(caretPos + diff, caretPos + diff);
    });
  };

  return (
    <Box mb={2}>
      <QuestionTitle label={label} sx={sharedStyles.label(isFocused)} />

      <TextField
        {...rest}
        fullWidth
        size="small"
        name={name}
        value={display}
        variant="outlined"
        inputMode="decimal"
        inputRef={inputRef}
        onChange={handle}
        placeholder="$"
        sx={sharedStyles.textField}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </Box>
  );
}

const digitsOnly = (str) => (str ?? "").replace(/\D/g, "");
const digitsToNum = (digits, fd = 2) => Number(digits) / 10 ** fd;
const formatCurr = (digits, { locale = "en-US", symbol = "$", fd = 2 } = {}) =>
  digits === ""
    ? ""
    : `${symbol} ${digitsToNum(digits, fd).toLocaleString(locale, {
        minimumFractionDigits: fd,
        maximumFractionDigits: fd,
      })}`;
